import { useCallback } from 'react';
import { useRefetchQuery } from 'src/features/common/hooks/useRefetchQuery';

export const useUpdateMillerColumns = () => {
  const refetch = useRefetchQuery();

  return useCallback(() => refetch('get-item-ancestors'), [refetch]);
};
